import React from "react";

import OBTS from "./Common/OBTS";

function NamchiDashboard() {
  return (
    <div className="row m-0">
      <div className="col col-12 col-md-6 col-lg-6">
        <div className="graph-outline mb-3">
          <OBTS depo="50" />
        </div>
      </div>
    </div>
  );
}

export default NamchiDashboard;
